import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Select, Input, Row, Col } from "antd";
import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";

const DynamicAddExpense = ({ form, handleSubmit, setCounterSales }) => {
  const expensesType = useSelector((state) => state.shopDetails.expensesType);
  const [expenseAmounts, setExpenseAmounts] = useState({});
  const onFieldsChange = (changed_Field) => {
    if (changed_Field.length > 0) {
      const changedField = changed_Field[0];
      console.log("changedField", changed_Field);
      if (changedField.name[2] === "expenseAmount") {
        setExpenseAmounts((prev) => ({
          ...prev,
          [changedField.name[1]]: changedField.value,
        }));
      }
    }
  };

  useEffect(() => {
    const values = Object.values(expenseAmounts);
    const totalNewExpense = values
      .filter(Boolean)
      .reduce((acc, cur) => acc + parseFloat(cur), 0);
    setCounterSales((prev) => {
      return {
        ...prev,
        totalNewExpense,
      };
    });
  }, [expenseAmounts]);

  const handleRemove = (remove, name) => {
    remove?.();
    setExpenseAmounts((prev) => ({
      ...prev,
      [name]: undefined,
    }));
    console.log("name", name);
  };

  return (
    <Form
      style={{
        position: "relative",
      }}
      form={form}
      name="dynamic_form_nest_item"
      autoComplete="off"
      size="middle"
      layout="vertical"
      requiredMark={false}
      scrollToFirstError={true}
      onFinish={handleSubmit}
      onFieldsChange={onFieldsChange}
    >
      <Form.List name="expenses">
        {(fields, { add, remove }, arr) => (
          <>
            {fields.length === 0 && (
              <Button
                style={{
                  margin: 0,
                  padding: 0,
                  color: "#000",
                  display: "flex",
                  alignItems: "center",
                }}
                size="small"
                type="link"
                onClick={() => add()}
                icon={
                  <PlusOutlined
                    style={{
                      color: "#CF0000",
                    }}
                  />
                }
              >
                Add Expenses
              </Button>
            )}
            {fields.length > 0 && <h6>Expenses</h6>}

            {fields.map(({ key, name, ...restField }) => (
              <Row
                key={key}
                gutter={30}
                align="center"
                justify={"space-between"}
                style={{
                  maxWidth: "98%",
                }}
              >
                <Col span={8}>
                  {" "}
                  <Form.Item
                    {...restField}
                    label="Type"
                    style={{
                      marginBottom: 10,
                    }}
                    name={[name, "expenseType"]}
                    rules={[
                      {
                        required: true,
                        message: "Type is Required",
                      },
                    ]}
                  >
                    <Select>
                      {expensesType.map((i) => {
                        return (
                          <Select.Option value={i.expensesTypeId}>
                            {i.expensesTypeName}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...restField}
                    label="Payment Method"
                    name={[name, "paymentMethod"]}
                    initialValue="cash"
                    labelAlign="left"
                    labelCol={24}
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <div>Cash</div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...restField}
                    label="Amount"
                    labelAlign="left"
                    labelCol={24}
                    style={{
                      marginBottom: 10,
                    }}
                    name={[name, "expenseAmount"]}
                    rules={[
                      {
                        required: true,
                        message: "Amount is Required",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      style={{
                        width: "100%",
                      }}
                      placeholder="Enter Expense Amount"
                    />
                  </Form.Item>
                </Col>
                <span
                  style={{
                    marginLeft: "auto",
                    position: "relative",
                    top: "-40px",
                    left: "20px",
                  }}
                >
                  <MinusCircleOutlined
                    onClick={() => handleRemove(remove(name), name)}
                  />
                </span>
                {fields.length >= 1 && (
                  <div>
                    <Button
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 10,
                        background: "green",
                        color: "#fff",
                        borderRadius: "50%",
                      }}
                      type="link"
                      onClick={() => {
                        add();
                      }}
                      icon={<PlusOutlined />}
                    ></Button>
                  </div>
                )}
              </Row>
            ))}
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default memo(DynamicAddExpense);
